import {
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_QUEUE
)
